import EndpointService from '@/services/endpoint'
import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: ''
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error
}

// mutations
const mutations = {
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    const tempData = state.data
    tempData.push(model)
    Vue.set(state, 'data', tempData)
    // state.data.push(model)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    const index = state.data.findIndex(m => m.id === model.id)
    state.data[index] = model
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  setError(state, error) {
    state.error = error
  }
}

const actions = {
  listAll({ commit, state }, options = {}) {
    return EndpointService.listAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  findAll({ commit, state }, options) {
    return EndpointService.findAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  save({ commit, state }, model) {
    commit('setError', '')
    if (!model.id) {
      return EndpointService.create(model).then((res) => {
        if (res.result) {
          commit('appendData', res.result)
          return res
        } else {
          const error = (res && res.response && res.response.data) ? res.response.data : res
          commit('setError', error)
          return Promise.reject(error)
        }
      })
    } else {
      return EndpointService.update(model).then((res) => {
        commit('updateData', res.result)
        return res
      })
    }
  },
  delete({ commit, state }, id) {
    return EndpointService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
